module.exports = __webpack_public_path__ + "static/media/bedding-light-gray.066c487e.svg";